import Image from "next/image";
import { classNames }from "../../../helpers/common.helpers";
import { urlForImage } from '~/lib/sanity.image';
import { Typography } from '../../../lib/mt-native'
import blank from "../../../../images/blank.webp";

export default function GalleryItem({
    id,
    title,
    href,
    image,
    fill = false
}) { 

    return (
      <div key={id}>
        <a href={fill ? null: href}>
            {image ? (
              <figure className="relative">
                <Image
                  src={urlForImage(image).url()}
                  alt={title ? title: "gallery item"}
                  width={0}
                  height={0}
                  sizes="100vw"
                  style={{ width: '100%', height: 'auto' }} 
                  className="h-40 w-full max-w-full object-cover object-center"
                />  
                {title && (
                <figcaption className="absolute bottom-4 left-4 ">
                  <Typography className="text-white text-xl w-36">{title}</Typography>
                </figcaption>
                )}
              </figure>            
            ) : (
              fill && (
                <figure className="relative">
                <Image
                  src={blank}
                  alt={"gallery item"}
                  width={0}
                  height={0}
                  sizes="100vw"
                  style={{ width: '100%', height: 'auto' }} 
                  className="h-40 w-full max-w-full object-cover object-center"
                />  
              </figure>
              )
            )}      
          </a>        
      </div>
    )    
  }
